import { createStore } from "vuex";

const state = {
    location: {
        app:
            window.location.pathname.split("/").length > 1
                ? "/" + window.location.pathname.split("/")[1]
                : "",
        page:
            window.location.pathname.split("/").length > 2
                ? "/" + window.location.pathname.split("/")[2]
                : "",
    },
    settings: {},
    token: null,
    user: null,
    bladePage: true,
};

const getters = {
    appPath: (state) => {
        return state.location.app + state.location.page;
    },
};

const mutations = {
    registerState(state, payload) {
        for (const [key, value] of Object.entries(payload)) {
            state[key] = value;
        }
    },
};

const actions = {};

export default createStore({
    state,
    getters,
    mutations,
    actions,
});
